import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/ui/Layout';
import { SignIn } from '@/routes/SignIn';
import { Dashboard } from '@/routes/Dashboard';
import { Editor } from '@/routes/Editor';
import { Settings } from '@/routes/Settings';
import { Billing } from '@/routes/Billing';
import { Characters } from '@/routes/Characters';
import { Terms, Privacy } from '@/routes/Legal';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/editor/:id" element={<Editor />} />
          <Route path="/characters" element={<Characters />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/billing" element={<Billing />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
